export enum FileListLoadingStatus {
    none, // initial state
    Loading, // list is loading
    Success, // success
    PartialSuccess, // partial success
    Failed, // failed
}

export default FileListLoadingStatus;
